/* Kitchen product tabs: tab switching, weight pills, qty stepper, quick add. */
if (!customElements.get('kitchen-tabs')) {
  customElements.define('kitchen-tabs', class KitchenTabs extends HTMLElement {
    connectedCallback() {
      this.d = this.dataset;
      // The theme only loads wishlist.js when its header wishlist setting is on; load it once if this section needs it.
      if (this.d.wishlistSrc && !customElements.get('wishlist-item') && !window.__ktWishlistLoading) {
        window.__ktWishlistLoading = true;
        const sc = document.createElement('script');
        sc.src = this.d.wishlistSrc;
        sc.defer = true;
        document.head.append(sc);
      }
      this.money = new Intl.NumberFormat(this.d.locale, { style: 'currency', currency: this.d.currency });
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(n);
          this.tabs[n].focus();
        });
      });
      this.addEventListener('click', (e) => {
        const step = e.target.closest('.kt-qty__btn');
        if (!step) return;
        const input = step.parentElement.querySelector('.kt-qty__in');
        input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10)));
      });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('pointerover', (e) => {
          const media = e.target.closest && e.target.closest('.kt-card__media.has-hover:not(.is-primed)');
          if (media) this.primeHover(media);
        });
      }
      this.addEventListener('change', (e) => {
        if (e.target.matches('.kt-pill input')) this.onVariant(e.target);
      });
      this.addEventListener('submit', (e) => {
        if (!e.target.matches('.kt-card__form')) return;
        e.preventDefault();
        this.add(e.target);
      });
    }

    primeHover(media) {
      media.classList.add('is-primed');
      const img = media.querySelector('.kt-card__img--hover');
      if (!img) return;
      img.addEventListener('load', () => media.classList.add('is-ready'), { once: true });
      img.loading = 'eager';
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
    }

    select(i) {
      this.tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (!panel) return;
        const tpl = panel.querySelector(':scope > template');
        if (on && tpl) panel.replaceChildren(tpl.content.cloneNode(true));
        panel.hidden = !on;
      });
      this.tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    onVariant(radio) {
      const form = radio.closest('form');
      const price = parseInt(radio.dataset.price, 10);
      const compare = parseInt(radio.dataset.compare, 10);
      const available = radio.dataset.available === 'true';
      form.querySelector('input[name="id"]').value = radio.value;
      const priceEl = form.querySelector('[data-price]');
      priceEl.innerHTML = '';
      const now = document.createElement('span');
      now.className = 'kt-card__now';
      now.textContent = radio.dataset.money || this.money.format(price / 100);
      priceEl.append(now);
      if (this.d.showCompare === 'true' && compare > price) {
        const was = document.createElement('s');
        was.className = 'kt-card__was';
        was.textContent = radio.dataset.moneyCompare || this.money.format(compare / 100);
        priceEl.append(was);
      }
      const btn = form.querySelector('.kt-add');
      btn.disabled = !available;
      btn.querySelector('.kt-add__txt').textContent = available ? this.d.add : this.d.soldOut;
    }

    async add(form) {
      const btn = form.querySelector('.kt-add');
      const txt = btn.querySelector('.kt-add__txt');
      const notify = document.querySelector('cart-notification');
      const sections = notify && notify.getSectionsToRender ? notify.getSectionsToRender().map((x) => x.id) : [];
      btn.disabled = true;
      txt.textContent = this.d.adding;
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(form.querySelector('input[name="id"]').value), quantity: Number(form.querySelector('.kt-qty__in').value) || 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message);
        if (notify && notify.renderContents && data.sections) {
          notify.renderContents(data);
        } else {
          const cart = await (await fetch('/cart.js')).json();
          document.querySelectorAll('.header__actions_btn_cart_num, .cart-count-bubble span').forEach((el) => { el.textContent = cart.item_count; });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        txt.textContent = this.d.added;
        setTimeout(() => { txt.textContent = this.d.add; btn.disabled = false; }, 1600);
      } catch (err) {
        txt.textContent = err.message || this.d.add;
        setTimeout(() => { txt.textContent = this.d.add; btn.disabled = false; }, 2500);
      }
    }
  });
}
